import {DisplaySmall} from '@/componentLibrary/components/typography/Display';
import {Wrapper} from '@/pages/PersonalityTestIrt/pages/PersonalityTest/components/PersonalityTestForm/components/QuestionTitle/styled';
import {QuestionTitleProps} from '@/pages/PersonalityTestIrt/pages/PersonalityTest/components/PersonalityTestForm/components/QuestionTitle/types';

export const QuestionTitle = ({children}: QuestionTitleProps) => (
    <Wrapper>
        <DisplaySmall>{children}</DisplaySmall>
    </Wrapper>
);
